export const inlineDownload = {
  InlineDownloadReports_Column_EmailFrequency: _TL_('How often'),
  InlineDownloadReports_EmailAndScheduling_Frequency_None: _TL_('One time'),
  InlineDownloadReports_EmailAndScheduling_Frequency_Daily_Template: _TL_('at {{hour}}'),
  InlineDownloadReports_EmailAndScheduling_Frequency_Weekly_Template: _TL_('on {{dayOfWeek}} at {{hour}}'),
  InlineDownloadReports_EmailAndScheduling_Frequency_Monthly_Template: _TL_('on day {{dayOfMonth}} of every month at {{hour}}'),
  InlineDownloadReports_Action_UnsubscribeMe_Failed_NotSubscribed: _TL_('You didn\'t subscribe to report "{{report}}"'),
  InlineDownloadReports_Action_UnsubscribeMe_Failed: _TL_('Failed to unsubscribe from report "{{report}}"'),
  InlineDownloadReports_Action_UnsubscribeMe_Succeeded: _TL_('You have unsubscribed from report "{{report}}"'),
};
